import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './assets/css/reset.css'; // 修改默认样式
// import './assets/css/border.css'; // 修改移动端的边框问题
import Vant from 'vant';
import FastClick from 'fastclick';
import echarts from 'echarts';
import 'lib-flexible/flexible.js';
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
/* eslint-disable */
// 修复ios 输入框获取焦点延迟问题
FastClick.prototype.focus = function (targetElement) {
    var length
    // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
    if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
      length = targetElement.value.length
      targetElement.setSelectionRange(length, length)
      //  修复ios 11.3以上不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出
      targetElement.focus()
    } else {
      targetElement.focus()
    }
  }
FastClick.attach(document.body);
Vue.use(Vant);
router.afterEach((to, from) => {
  // 每次进入路由都会触发
    // if (window._hmt) {
    //     if (to.path) {
    //       if (window._hmt) {
    //         window._hmt.push(['_setAutoPageview', false]);
    //         window._hmt.push(['_trackPageview', '/#' + to.fullPath]); // 如果不是根路径，需要指定第二个参数的路径
    //       }
    //     }
    // }
});
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
